import EmptyStateImg from "../../assets/illustrations/empty-state.png";
import {ReactNode} from "react";

import "./empty-state.css";

interface EmptyStateProps {
    imgSrc?: string;
    title?: string;
    subTitle?: string;
    actions?: ReactNode | ReactNode[] | null;
    className?: string;
}

const EmptyState = ({
    imgSrc = EmptyStateImg,
    title = 'Looks pretty empty',
    subTitle = 'Try adding new items',
    actions = null,
    className,
}: EmptyStateProps) => {
    return (
        <div className={`empty-state-container ${className || ''}`}>
            <img src={imgSrc} />
            <div className="title">{title}</div>
            {subTitle ? <div className="sub-title">{subTitle}</div> : null}
            <div className="actions">{actions}</div>
        </div>
    )
}

export default EmptyState;